import React, { useEffect, useState } from "react";
import AdminTabelHeader from "../../../components/layout/header/AdminTabelHeader";
import { image, title } from "motion/react-client";
import { useMutation, useQuery } from "react-query";
import { BASEURL } from "../../../../utils/BaseUrl";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import TraingleLoading from "../../../../common/Loading/TraingleLoading";
import Swal from "sweetalert2";
const HomeSection1Form = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const locdata = location?.state?.data;
  const type = location?.state?.type;

  const [data, setData] = useState({
    image: "",
    title: "",
    describe: "",
    imageErr: "Unchecked",
    titleErr: "Unchecked",
    describeErr: "Unchecked",
  });
  const checkSumbit = () => {
    let status = true;

    if (
      data.imageErr === "success" &&
      data.titleErr === "success" &&
      data.describeErr === "success"
    ) {
      status = false;
    } else {
      status = true;
    }
    return status;
  };
  const [images, setImage] = useState("");

  const onChangeHandelar = (e) => {
    const temp = { ...data };
    const trimmedValue = e.target.value?.trim(); // Trim whitespace once
    const maxLengthRegex = new RegExp("^.{1,4000}$"); // Define regex once

    if (e.target.name === "image") {
      temp[e.target.name + "Err"] =
        e.target.value === undefined ? "Error" : "Success";
      temp[e.target.name] = e.target.files[0];
    } else {
      temp[e.target.name + "Err"] = maxLengthRegex.test(trimmedValue)
        ? "Success"
        : "Error";
      temp[e.target.name] = e.target.value;
    }

    temp[e.target.name] = e.target.value;

    setData(temp);
  };
  const {
    data: getView,
    isSuccess,
    isLoading,
  } = useQuery(
    ["gethomeid", locdata?.id],
    () =>
      axios.get(`${BASEURL}company-intro/${locdata?.id}`).then((res) => {
        return res?.data;
      }),
    {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      enabled: !!locdata?.id,
      onSuccess: (response) => {
        const data = response?.companyIntro;

        setImage(data?.image_url);
        setData({
          describe: data?.content,
          title: data?.head,
        });
      },
    }
  );

  const mutation = useMutation({
    mutationFn: (values) => {
      if (type == "edit") {
        return axios.put(`${BASEURL}company-intro/${locdata?.id}`, values);
      } else {
        return axios.post(`${BASEURL}company-intro`, values);
      }
    },
    onSuccess: (response) => {
      // const data = response?.data;
      // if (data) {
      //   navigate(-1);
      // }

      Swal.fire({
        title: "Success",
        icon: "success",
        draggable: false,
        // confirmButtonColor:"#fcd70c",
        customClass: {
          confirmButton: "custom-confirm-button", // Add a custom class for styling
        },
      }).then(() => {
        navigate(-1);
      });
    },
    onError: (res) => {
      const errorMessages = res?.response?.data?.errors
        ?.map((v) => `<p>${v?.msg}</p>`)
        .join(""); // Convert to a single HTML string

      Swal.fire({
        title: "Error!",
        html: errorMessages,
        icon: "error",
        draggable: false,
        customClass: {
          confirmButton: "custom-confirm-button",
        },
      });
    },
  });
  const handleImageChange = (e) => {
    const file = e.target.files[0];

    setImage(file);
  };
  const handleSubmit = (e) => {
    const formdata = new FormData();
    if (images?.name) {
      formdata.append("image", images);
    }
    formdata.append("head", data?.title);
    formdata.append("content", data?.describe);

    mutation.mutate(formdata);
  };

  const disableHandar = () => {
    let constant = false;
    if (
      data?.describeErr == "Success" &&
      data?.imageErr == "Success" &&
      data?.titleErr == "Success"
    ) {
      constant = false;
    } else {
      constant = true;
    }
    return constant;
  };

  return (
    <div>
      {mutation.isLoading && <TraingleLoading />}
      <AdminTabelHeader
        title={type == "edit" ? "Edit Image Carousel" : "Add Image Carousel"}
        btnStatus={false}
      />
      <div className="p-4">
        <div className="grid grid-cols-1 gap-4">
          <div>
            <label className="label">Title</label>
            <input
              name="title"
              className={`input
                ${
                  data?.titleErr == "Error"
                    ? "input-error"
                    : data?.titleErr == "Success"
                    ? "input-success"
                    : ""
                }
                `}
              type="text"
              placeholder="Enter your name"
              value={data?.title}
              onChange={(e) => onChangeHandelar(e)}
            />
          </div>
          <div>
            <label className="label">Description</label>
            <textarea
              name="describe"
              className={`textarea 
                ${
                  data?.describeErr == "Error"
                    ? "input-error"
                    : data?.describeErr == "Success"
                    ? "input-success"
                    : ""
                }
              `}
              value={data?.describe}
              onChange={(e) => onChangeHandelar(e)}
            />
          </div>
          {/* <div>
            <label className="label">Banner Image</label>
            <input
              name="image"
              className={`input 
                ${
                  data?.imageErr == "Error"
                    ? "input-error"
                    : data?.imageErr == "Success"
                    ? "input-success"
                    : ""
                }
                `}
              type="file"
              placeholder="Enter your name"
              // value={images}
              onChange={(e) => {
                setImage(e.target.files[0]);
              }}
            />
          </div> */}
          <div className="grid grid-cols-1 gap-4">
            <label className="label">Image</label>
            <div className="flex flex-col items-center justify-center p-6 bg-gray-100 rounded-lg shadow-md w-80">
              <label
                htmlFor="imageInput"
                className="cursor-pointer flex flex-col items-center justify-center w-full h-64 bg-white border-2 border-dashed border-blue-400 rounded-lg hover:bg-blue-50 transition duration-300"
              >
                {images ? (
                  <img
                    src={images?.name ? URL?.createObjectURL(images) : images}
                    alt="Preview"
                    className="w-full h-full object-cover rounded-md"
                  />
                ) : (
                  <div className="text-center">
                    <svg
                      className="w-10 h-10 text-blue-400 mx-auto"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M12 4v16m8-8H4"
                      ></path>
                    </svg>
                    <p className="text-sm text-gray-500 mt-2">
                      Click to upload image
                    </p>
                  </div>
                )}
              </label>
              <input
                type="file"
                id="imageInput"
                accept="image/*"
                className="hidden"
                onChange={(e) => handleImageChange(e)}
              />
              {images && (
                <button
                  className="mt-4 px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 transition duration-300"
                  onClick={() => setImage("")}
                >
                  Remove Image
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="flex justify-end my-4 ">
          <button
            onClick={() => navigate(-1)}
            // disabled={checkSubmit()}
            className={"formSubmit mr-8 cursor-pointer "}
          >
            Cancel
          </button>
          <button
            className={`formSubmit `}
            // disabled={checkSumbit()}
            onClick={() => handleSubmit()}
          >
            {type == "edit" ? "Update" : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HomeSection1Form;
